var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"list-menu-divider mt-2 pb-2 border-gray-200 border-t",attrs:{"tabindex":"-1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }